import {
    ActionButtonsWrapper,
    Checkbox,
    ColumnLayout,
    IconSettings,
    MessageBoxTitle,
    MessageBoxWrapper,
    PrimaryButton,
} from 'components/ui';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setResolution, videoSettingsSelector } from 'slices';
import * as S from '../audio-video-settings/AudioVideoSettings.style';
import * as Q from '../qa-settings/QASettings.style';

export const QASettings = ({ onClose }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { resolution } = useSelector(videoSettingsSelector);

    const resetExpirationWarning = () => {
        localStorage.removeItem('expiration_warnings');
    };
    const resetFirstConnectionWarning = () => {
        localStorage.removeItem('firstConnection');
    };

    const box = (
        <MessageBoxWrapper>
            <MessageBoxTitle title="QA Settings" Icon={IconSettings} />
            <S.ContentWrapper>
                <ColumnLayout>
                    <Q.SettingsRow>
                        <span>Expiration warnings</span>
                        <PrimaryButton onClick={resetExpirationWarning}>
                            Clear
                        </PrimaryButton>
                    </Q.SettingsRow>
                    <Q.SettingsRow>
                        <span>First connection warning</span>
                        <PrimaryButton onClick={resetFirstConnectionWarning}>
                            Clear
                        </PrimaryButton>
                    </Q.SettingsRow>
                    <Q.SettingsRow>
                        <span>1080p</span>
                        <S.CheckboxWrapper>
                            <Checkbox
                                isChecked={resolution === '1080p'}
                                onChange={(checked) => {
                                    dispatch(
                                        setResolution(
                                            checked ? '1080p' : '720p'
                                        )
                                    );
                                }}
                            />
                            <S.Label>
                                {t(
                                    resolution === '1080p'
                                        ? 'buttons.on'
                                        : 'buttons.off'
                                )}
                            </S.Label>
                        </S.CheckboxWrapper>
                    </Q.SettingsRow>
                </ColumnLayout>
            </S.ContentWrapper>
            <ActionButtonsWrapper>
                <PrimaryButton onClick={onClose}>
                    {t('buttons.close')}
                </PrimaryButton>
            </ActionButtonsWrapper>
        </MessageBoxWrapper>
    );

    return ReactDOM.createPortal(box, document.body);
};
